import { SettingsContext } from './context';

export default SettingsContext;
